module.exports = __webpack_public_path__ + "img/cia_logo_color.7501663e.svg";